import { MODAL_OPEN, MODAL_CLOSE } from './types';

const initialState = {
  isOpenMobileMenu: false,
  openModals: [],
  params: {},
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_OPEN:
      return {
        ...state,
        openModals: [...state.openModals, action.payload],
        params: { ...state.params, [`${action.payload}`]: action.params },
      };

    case MODAL_CLOSE:
      const newParams = { ...state.params };
      Reflect.deleteProperty(newParams, `${action.payload}`);
      return {
        ...state,
        openModals: state.openModals.filter((id) => id !== action.payload),
        params: { ...newParams },
      };

    default:
      return state;
  }
};

export default uiReducer;
